import Modals from '@/components/UI/Modals';
import { Button, Form, Input } from '@arco-design/web-react';
import React, { useState } from 'react'
import iconImg from "@/assets/create-space/project-modal-icon.png";
import FormItem from '@arco-design/web-react/es/Form/form-item';
import useRename from '@/requestHooks/createSpace/material/useRename';
import { on } from 'events';

export default function RenameModal({cancel, visible, form, editId, onOk}) {
  const { handleRenameRequest } = useRename();
  const [confirmLoading, setConfirmLoading] = useState(false)
  const confirm = () => {
    form.validate().then(formData => {
      setConfirmLoading(true)
      handleRenameRequest(formData.folderName, editId).then(() => {
        onOk()
      }).finally(() => {
        setConfirmLoading(false)
      })
    })
  }
  return (
    <Modals
      width={486}
      title="修改文件夹名称"
      subMiteBtn={
        <Button
          loading={confirmLoading}
          type="primary"
          onClick={confirm}>
          确认
        </Button>
      }
      cancelBtn={
        <Button
          onClick={() => {
            cancel()
          }}>
          取消
        </Button>
      }
      titleIcon={<img style={{ width: '26px'}} src={iconImg} />}
      closeIcon={null}
      visible={visible}>
      <div className="modal-content">
        <Form
          layout="vertical"
          form={form}
          style={{ width: "100%" }}
          autoComplete="off">
          <FormItem
            rules={[
              {
                required: true,
                message: "文件夹名称是必填项",
              },
              {
                validator: (value, cb) => {
                  if (value && value.length > 20) {
                    return cb("文件夹名称不能超过20个字符");
                  }
                  return cb();
                },
              },
            ]}
            field="folderName"
            label="文件夹名称">
            <Input placeholder="请输入文件夹名称" />
          </FormItem>
        </Form>
      </div>
    </Modals>
  )
}
